/**
 * Define snackbar plugin
 *
 * @author minkyoung.park@emcast.com
 */
import SnackBar from './SnackBar.vue'

const snackbarPlugin = {
    install(Vue, optiuons) {
        let snackbarConstructor = Vue.extend(SnackBar)
        let snackbarInstance = null

        snackbarInstance = new snackbarConstructor({
            el: document.createElement('div')
        })

        snackbarInstance.attachMaterial(snackbarInstance.$el)
        document.body.appendChild(snackbarInstance.$el)

        Vue.prototype.$snackOpen = function (payload) {
            return new Promise((resolve, reject) => {
                snackbarInstance.open(payload, false).then((data) => {
                    resolve(data)
                }).catch((err) => {
                    reject(err)
                })
            })
        },

        Vue.prototype.$snackClose = function () {
            snackbarInstance.close()
        }
    }
}

export default snackbarPlugin